import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { isAuthenticated } from '../../../../../../helpers'
import { convertDate } from '../../../../../../components/list-items/components/eventItem/constants'
import { Card } from '../../../../../../components/UI'
import PassportLogo from '../../../../../../assets/logo-sm.png'
import starImage from '../../../../../../assets/svg/Star.svg'
import starGoldImage from '../../../../../../assets/svg/StarGold.svg'
import { getStatusColor, getStatusText } from './helpers'
import useFollowHandler from './hooks/useFollowHandler'
import styles from './styles.module.scss'

const EventCard = ({
  id,
  name,
  media,
  logo,
  startDate,
  startedAt,
  endedAt,
  endDate,
  follow,
  status,
}) => {
  const history = useHistory()
  const { star, followHandler } = useFollowHandler(id, name, follow)

  const handleEventClick = useCallback(() => {
    history.push(`/eventPage/${id}`)
  }, [history, id])

  const handleStarClick = useCallback(
    e => {
      e.stopPropagation()
      followHandler()
    },
    [followHandler]
  )

  return (
    <Card className={styles.eventCard} onClick={handleEventClick}>
      <div className={styles.eventHeader}>
        <img
          src={media?.logo || logo || PassportLogo}
          className={styles.eventLogo}
          alt={name || 'Event'}
        />
      </div>

      {!!isAuthenticated() && (
        <img
          src={star ? starImage : starGoldImage}
          className={styles.eventStar}
          onClick={handleStarClick}
          alt='Follow event'
        />
      )}

      <div className={styles.eventContent}>
        <h3 className={styles.eventTitle}>{name || 'Event'}</h3>

        <div className={styles.eventDate}>
          <span className={styles.eventDateText}>
            {convertDate(startedAt || startDate, endedAt || endDate)}
          </span>

          {status && (
            <div
              className={styles.eventStatus}
              style={{ backgroundColor: getStatusColor(status) }}
            >
              {getStatusText(status)}
            </div>
          )}
        </div>
      </div>
    </Card>
  )
}

export default EventCard
